<footer >
  <section class="foot-main" *ngIf="showFooterMain">
    <div class="wrap-lg">
      <div class="foot-inner">
        <div class="foot-col">
          <img class="logo-img" src="assets/images/logo_dark.svg" alt="Logo" />
        </div>
        <div class="foot-col">
          <h5 class="foot-title">LEGAL</h5>
          <div class="foot-list">
            <div class="foot-item" (click)="route('grievanceRedressal')" >Grievance Redressal</div>
            <div class="foot-item" (click)="route('privacy')">Privacy Policy</div>
          </div>
        </div>
        <div class="foot-col">
          <h5 class="foot-title">NEED HELP?</h5>
          <div class="foot-list">
            <div class="foot-item" (click)="route('faq')">FAQs</div>
            <div class="foot-item" (click)="route('contactUs')">Contact Us</div>
            <div class="foot-item" (click)="route('emiCalculator')">EMI Calculator</div>
          </div>
        </div>
        <!-- <div class="foot-col last">
          <a (click)="openPlaystore()" href="#" class="store-sec">
            <img src="assets/images/landing/store_icon.svg" alt="playstore Icon"/>
            <div class="store-detail">
              <div class="store-info">GET IT ON</div>
              <div class="store-name">Google Play</div>
            </div>
          </a>
        </div> -->
      </div>
    </div>
  </section>
  <section class="foot-secondary" *ngIf="showFooterSecondary">
    <div class="wrap-lg">
      <div class="copt-right">
        <div class="foot-left-txt">Reach out to us at <a href="mailto:customersupport@northernarc.com">customersupport@northernarc.com</a></div>
        <div class="foot-right-txt">Copyright © 2023, Northern Arc. All Rights Reserved.</div>
      </div>
    </div>
  </section>
</footer>

<p-dialog header="" [(visible)]="visible" styleClass="cus-dialog-lg cus-dialog" [draggable]="false" [resizable]="false">
  <iframe width="100%" height="400px" [src]="iframeSrc" frameborder="0" allowfullscreen style="overflow: hidden;">
  </iframe>
</p-dialog>
